import React from 'react'
import { Select, MenuItem, FormControl } from '@material-ui/core'
import { Field } from 'react-formality'
import PropTypes from 'prop-types'
import that from '../../utilities/translationHelper'

const DistanceUnitField = ({ name, value, onChange, onBlur }) => (
	<Field
		supportsHelperText={false}
		component={FormControl}
		name={name}
		validate={{
			presence: true
		}}
	>
		<Select
			value={value}
			onChange={onChange}
			onBlur={onBlur}
			disableUnderline
		>
			<MenuItem value="cm">{that.context.translate('cm')}</MenuItem>
			<MenuItem value="in">{that.context.translate('in')}</MenuItem>
		</Select>
	</Field>
)

DistanceUnitField.propTypes = {
	name: PropTypes.string.isRequired,
	value: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	onBlur: PropTypes.func.isRequired
}

DistanceUnitField.defaultProps = {
	value: undefined
}

export default DistanceUnitField



// WEBPACK FOOTER //
// ./src/components/Edit/DistanceUnitField.jsx